import { AuthState } from '@owl-nest/services/src/user/types'
import { reducer as authReducer } from '@owl-nest/services/src/user/reducer'

/** @deprecated use `AuthState` from `@owl-nest/services` */
export type IdentityState = AuthState

/** @deprecated use `reducer` from `@owl-nest/services` */
export function reducer(...params: Parameters<typeof authReducer>): ReturnType<typeof authReducer> {
  return authReducer(...params)
}
